export default __webpack_public_path__ + "static/media/SvenskKod.0870390d.png";